import React from 'react';
import { useSelector } from 'react-redux';
import { Icon } from '@iq/react-components';
import StyledItem from '../../StyledItem';
import { getTimezone } from '../../../bundles/application';
import { utcToSite, datetimeString } from '../../../datetimeUtils';
import { STATUSES } from '../../../constants';

const HealthRisk = ({ risk, riskThreshold = {}, onClick }) => {
  const {
    shutdownWarning = 60,
    shutdownEmergency = 80,
    downtimeWarning = 8,
    downtimeEmergency = 14,
  } = riskThreshold;

  const timezone = useSelector(getTimezone);
  const { color: statusColor, icon: statusIcon } = STATUSES[risk.status] || {};
  const [r, g, b] = statusColor || [0, 0, 0];

  function truncateNumber(num) {
    if (typeof num !== 'number' || num == null || Number.isNaN(num)) {
      return 'N/A';
    }
    if (num < 1) {
      return '<1';
    }
    const truncated = Math.trunc(num * 10) / 10;
    return truncated.toFixed(1);
  }

  const getValueColor = (k, t) => {
    if (k === 'Shutdown Risk') {
      if (t >= shutdownEmergency) {
        return '#ED4747';
      }
      if (t >= shutdownWarning) {
        return '#F9C846';
      }
      return '#666666';
    }
    if (k === 'Downtime Risk') {
      if (t >= downtimeEmergency) {
        return '#ED4747';
      }
      if (t >= downtimeWarning) {
        return '#F9C846';
      }
      return '#666666';
    }
    return null;
  };

  const formatEventDatetime = (timestamp, withMs = true) =>
    datetimeString(utcToSite(timestamp, timezone), timezone, withMs);

  return (
    <StyledItem
      itemClass="risk-list-item"
      onClick={onClick}
      headerLabel={
        <div
          data-testid="header"
          className="risk-content"
        >
          <div
            data-testid="header-label"
            className="risk-content-status"
          >
            <div>
              <div className="risk-icon">
                <Icon
                  size="s"
                  icon={statusIcon}
                  style={{ color: `rgba(${r}, ${g}, ${b}, ${statusColor ? 1 : 0})` }}
                />
              </div>
              <div className="risk-status">{STATUSES[risk.status].text}</div>
            </div>
            <div className="risk-time">{formatEventDatetime(risk.eventDateTime)}</div>
          </div>
          <div
            data-testid="body"
            className="risk-body"
          >
            <div className="risk-title-info">
              <div className="risk-eventtext">{risk.eventText}</div>
              <div className="risk-component">{`${risk.event.remoteSource}`}</div>
            </div>

            <div className="risk-downtime">
              <div className="grid-item">
                <div
                  className="circle"
                  style={{
                    border: `3px solid ${getValueColor('Downtime Risk', risk.mttrDay)}`,
                  }}
                >
                  <div>{truncateNumber(risk.mttrDay)}</div>
                </div>
              </div>
              <div className="grid-item">
                <div
                  className="circle"
                  style={{
                    border: `3px solid ${getValueColor('Downtime Risk', risk.mttrWeek)}`,
                  }}
                >
                  <div>{truncateNumber(risk.mttrWeek)}</div>
                </div>
              </div>
              <div className="grid-item">
                <div
                  className="circle"
                  style={{
                    border: `3px solid ${getValueColor('Downtime Risk', risk.mttrMonth)}`,
                  }}
                >
                  <div>{truncateNumber(risk.mttrMonth)}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      bodyActionsPosition="center"
    />
  );
};

export default HealthRisk;
